export default __webpack_public_path__ + "static/media/b11.2c8f9e05.jpg";